<template>
  <SeoContent
    v-if="productResponse && technicalSpecificationsResponse"
    class="my-32 md:my-72"
    data-id="seo-technical-specs"
    :description="productResponse.seo.description ?? ''"
    :model="productResponse.model"
    :technical-specifications="technicalSpecificationsResponse"
    :title="productResponse.titles.raw"
  >
    <ScoreCard
      class="pb-24"
      :productModel="productResponse.model"
      :scores="productResponse.scores"
    />
  </SeoContent>
</template>

<script setup lang="ts">
import ScoreCard from '~/scopes/product-core/components/presentationals/ScoreCard/ScoreCard.vue'
import SeoContent from '~/scopes/product-core/components/presentationals/SeoContent/SeoContent.vue'
import { useFetchProduct } from '~/scopes/product-core/composables/useFetch/useFetchProduct/useFetchProduct'
import { useFetchTechnicalSpecifications } from '~/scopes/product-core/composables/useFetch/useFetchTechnicalSpecifications/useFetchTechnicalSpecifications'

const { data: productResponse } = useFetchProduct()
const { data: technicalSpecificationsResponse } =
  useFetchTechnicalSpecifications()
</script>
